module.exports = __webpack_public_path__ + "static/img/main-accommodation-menu-img01.6a842a2e.png";